import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      // Small delay to allow navigation to complete
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    setMobileMenuOpen(false);
  };
  const handleApplyClick = () => {
    navigate('/application');
    setMobileMenuOpen(false);
  };
  return <>
      {/* Top Utility Bar */}
      <div className={`fixed top-0 w-full z-50 bg-zinc-950 border-b border-zinc-800 transition-all duration-300 ${isSticky ? 'hidden' : ''}`} data-id="element-531">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-532">
          <div className="hidden md:flex items-center justify-end gap-6 py-2 text-xs text-zinc-400" data-id="element-533">
            <a href="mailto:info@vcacapitaladvisors.com" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-534">
              <MailIcon className="w-3.5 h-3.5" data-id="element-535" />
              info@vcacapitaladvisors.com
            </a>
            <a href="tel:929-816-6805" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-536">
              <PhoneIcon className="w-3.5 h-3.5" data-id="element-537" />
              (929) 816-6805
            </a>
          </div>
        </div>
      </div>

      <nav className={`fixed w-full z-40 transition-all duration-300 border-b ${isSticky ? 'top-0 bg-black/90 backdrop-blur-md border-zinc-800 py-3' : 'top-8 bg-black border-transparent py-5'}`} data-id="element-538">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-539">
          <div className="flex justify-between items-center" data-id="element-540">
            <div className="flex items-center cursor-pointer" onClick={() => navigate('/')} data-id="element-541">
              {/* Using text logo for cleaner look if image doesn't match black theme, or keep image if transparent */}
              <div className="text-2xl font-bold tracking-tighter text-white" data-id="element-542">
                VCA Capital Advisors
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-543">
              <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white font-medium transition-colors text-sm tracking-wide" data-id="element-544">
                Services
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-white font-medium transition-colors text-sm tracking-wide" data-id="element-545">
                How It Works
              </button>
              <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white font-medium transition-colors text-sm tracking-wide" data-id="element-546">
                About
              </button>
              <button onClick={handleApplyClick} className="bg-white text-black px-6 py-2.5 rounded-full font-bold hover:bg-gray-200 transition-colors shadow-sm text-sm tracking-wide" data-id="element-547">
                Get Started
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2" data-id="element-548">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-549" /> : <MenuIcon className="w-6 h-6" data-id="element-550" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="md:hidden bg-black border-t border-zinc-800 py-4 px-4 flex flex-col space-y-4 absolute w-full h-screen" data-id="element-551">
            <button onClick={() => scrollToSection('services')} className="text-left text-gray-300 font-medium py-3 border-b border-zinc-900 hover:text-white" data-id="element-552">
              Services
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-left text-gray-300 font-medium py-3 border-b border-zinc-900 hover:text-white" data-id="element-553">
              How It Works
            </button>
            <button onClick={() => scrollToSection('about')} className="text-left text-gray-300 font-medium py-3 border-b border-zinc-900 hover:text-white" data-id="element-554">
              About
            </button>
            <button onClick={handleApplyClick} className="w-full bg-white text-black px-6 py-4 rounded-full font-bold hover:bg-gray-200 transition-colors text-center mt-4" data-id="element-555">
              Get Started
            </button>
          </div>}
      </nav>
    </>;
}